import { SITE_FOR_MAPVIEW } from '@/types/site'
import { STATION_DETAIL } from '@/types/stations'
import type { DeletedStation } from './stationDeletionEvent'

export const initialState: WeatherDashboardState = {
  stations: [],
  deletedStations: [],
  siteData: [],
  isLoading: false,
  isLoadingSite: false,
}

export interface WeatherDashboardState {
  stations: STATION_DETAIL[]
  deletedStations: DeletedStation[]
  siteData: SITE_FOR_MAPVIEW[]
  isLoading: boolean
  isLoadingSite: boolean
}
